import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { HotelRulesModalComponent } from '../../components/hotel-rules-modal/hotel-rules-modal.component';
import { SeasonTipsComponent } from '../../components/season-tips/season-tips.component';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { MatRippleModule } from '@angular/material/core';
import { popupDirective } from '@shared/directives/popup.directive';
import { LoadingService } from '@shared/services/loading.service';
import { ModalService } from '@shared/services/modal.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-hotel-rules',
 standalone: true,
 imports: [CommonModule, MatButtonModule, SeasonTipsComponent, MatRippleModule, popupDirective],
 templateUrl: './hotel-rules.component.html',
 styleUrls: ['./hotel-rules.component.scss'],
})
export class HotelRulesComponent implements OnInit {
 @Input() set dataSource(value: any) {
  this.hotel = value;
 }

 hotel: any;
 dialog = inject(MatDialog);
 loadingService = inject(LoadingService);
 modalService = inject(ModalService);
 destroyRef = inject(DestroyRef);

 showModal() {
  const dialogRef = this.dialog.open(HotelRulesModalComponent, {
   panelClass: ['', 'w-screen', 'lg:w-[80%]', 'h-screen', '!max-w-full', 'lg:h-[90%]'],
   data: {
    //  dataSource: this.dataSource,
    headerComments: this.hotel,
    hid: 214,
   },
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {
    this.modalService.isAnyModalOpen.set(false);
   });

  dialogRef
   .afterOpened()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe(() => {
    this.modalService.isAnyModalOpen.set(true);
   });
 }

 ngOnInit(): void {}
}
